module.exports = __webpack_public_path__ + "static/media/17.747fc2c0.png";